import { AxiosInstance } from 'axios';
import { HttpResponse } from '@/interfaces';
import axiosClient from './axiosClientConfig';
import { ContactRequestI } from '@/interfaces/contact';

class ContactService {
	constructor(private client: AxiosInstance) {}

	async create(data: ContactRequestI): Promise<HttpResponse<any>> {
		return this.client.post('/contact-us', data);
	}
}

export const contactService = new ContactService(axiosClient);
